!function ($, global) {
    'use strict';

    var $window = $(global);
    var $toggle = $('#comments-main-toggle');
    var $container = $('#comments-main');

    var hash = location.hash.replace(/^#/, '');

    if($container.length) {
        if (hash.match(/^respond|^comment/)) {
            $container.collapse('show');
            $toggle.addClass('state-active');
        }

        $container.on('show.bs.collapse', function () {
            global.setTimeout(function () {
                var offset = $toggle.offset();
                var marginTop = parseInt($toggle.css('margin-top')) || 0;

                if (offset) {
                    global.smoothScroll(global, offset.top - marginTop - $window.scrollTop(), {
                        interrupt: true,
                        duration: 300
                    });
                }
            }, 200);
        });
    }

}(jQuery, window);